import {
  Route, Smartphone, Wallet, ClipboardCheck, MapPinned, TriangleAlert,
  CreditCard, Briefcase, ShieldCheck, FileCheck2, KeyRound, Flag,
  UserPlus, CalendarCheck, PlayCircle,
} from "lucide-react";

export const WEBINAR_URL =
  "https://kurierconnect.webinargeek.com/fahrzeugueberfuehrung-das-einsteiger-webinar-1";

// WebinarGeek embed config (loaded in index.html with shape:"link").
export const WG_FN = "mw_tUGzvHwxUUZ";
export const WG_IDENTIFIER = "3ff10387-b869-47cd-ac7e-814c48d7a4fd";

// Opens the official WebinarGeek registration modal.
// Falls back to the direct webinar URL if the embed is unavailable.
export const openWebinar = () => {
  if (typeof window === "undefined") return;
  const fn = window[WG_FN];
  if (typeof fn === "function") {
    try {
      fn("registrationEvent", "confirmSignup", []);
      return;
    } catch (e) {
      /* fall through to direct link */
    }
  }
  window.open(WEBINAR_URL, "_blank", "noopener");
};

export const NAV_LINKS = [
  { label: "Ablauf", id: "ablauf" },
  { label: "Webinar-Inhalte", id: "inhalte" },
  { label: "Verdienst", id: "verdienst" },
  { label: "FAQ", id: "faq" },
];

export const TRUST_ITEMS = [
  "Kostenlos teilnehmen",
  "Für Einsteiger geeignet",
  "Keine Vorkenntnisse erforderlich",
  "Deutschlandweit möglich",
  "Online anschauen",
];

export const PROCESS_STEPS = [
  {
    num: "01",
    icon: FileCheck2,
    title: "Auftrag auswählen",
    text: "Du entscheidest selbst, welche passenden Aufträge du annimmst – und wann du fahren möchtest.",
  },
  {
    num: "02",
    icon: KeyRound,
    title: "Fahrzeug übernehmen",
    text: "Du holst das Fahrzeug am vereinbarten Standort ab und dokumentierst die Übergabe.",
  },
  {
    num: "03",
    icon: Flag,
    title: "Fahrzeug zum Ziel bringen",
    text: "Du bringst das Fahrzeug sicher zum Zielort – und wirst für die Überführung bezahlt.",
  },
];

export const WEBINAR_CARDS = [
  {
    icon: Route,
    tag: "Grundlagen",
    title: "Wie Fahrzeugüberführung funktioniert",
    text: "Wie ein typischer Auftrag abläuft – von der Auftragsannahme über die Fahrzeugübernahme bis zur Ablieferung.",
  },
  {
    icon: Smartphone,
    tag: "Aufträge",
    title: "Wo du Aufträge findest",
    text: "Welche Möglichkeiten und Plattformen es gibt und wie du geeignete Überführungsaufträge findest.",
  },
  {
    icon: Wallet,
    tag: "Verdienst",
    title: "Was du verdienen kannst",
    text: "Wie die Vergütung funktioniert, welche Faktoren deinen tatsächlichen Verdienst beeinflussen und wie du beurteilst, ob sich ein Auftrag lohnt.",
  },
  {
    icon: ClipboardCheck,
    tag: "Einstieg",
    title: "Welche Voraussetzungen du brauchst",
    text: "Führerschein, Gewerbe und weitere organisatorische Grundlagen, die für den Einstieg wichtig sein können.",
  },
  {
    icon: MapPinned,
    tag: "Planung",
    title: "Wie du deine Touren richtig planst",
    text: "Warum Anreise, Rückfahrt, Bahnverbindungen und Zeitplanung entscheiden, ob ein Auftrag wirtschaftlich sinnvoll ist.",
  },
  {
    icon: TriangleAlert,
    tag: "Fehler vermeiden",
    title: "Welche Anfängerfehler du vermeiden solltest",
    text: "Typische Fehler, durch die neue Fahrer unnötig Zeit oder Geld verlieren – und wie du sie von Anfang an vermeidest.",
  },
];

export const AUDIENCE_ITEMS = [
  "du gerne Auto fährst",
  "du dir deine Zeit möglichst flexibel einteilen möchtest",
  "du nach einer zusätzlichen Verdienstmöglichkeit suchst",
  "du selbstständig arbeiten möchtest",
  "du wissen möchtest, wie man an echte Überführungsaufträge kommt",
  "du bisher keine Erfahrung mit Fahrzeugüberführung hast",
];

export const REQUIREMENTS = [
  {
    icon: CreditCard,
    title: "Führerschein",
    text: "Für Fahrzeugüberführungen benötigst du selbstverständlich eine entsprechende gültige Fahrerlaubnis.",
  },
  {
    icon: Smartphone,
    title: "Smartphone",
    text: "Viele Aufträge, Dokumentationen und Übergaben werden heute digital organisiert.",
  },
  {
    icon: Briefcase,
    title: "Gewerbliche Voraussetzungen",
    text: "Je nach Tätigkeit können gewerbliche bzw. steuerliche Voraussetzungen relevant sein. Im Webinar erfährst du, was Einsteiger dazu wissen sollten.",
  },
  {
    icon: ShieldCheck,
    title: "Zuverlässigkeit",
    text: "Du übernimmst fremde Fahrzeuge. Pünktlichkeit, sorgfältiger Umgang und ordentliche Dokumentation sind besonders wichtig.",
  },
];

export const WEBINAR_STEPS = [
  {
    num: "1",
    icon: UserPlus,
    title: "Kostenlos anmelden",
    text: "Trage dich für das Webinar ein.",
  },
  {
    num: "2",
    icon: CalendarCheck,
    title: "Termin auswählen",
    text: "Wähle einen verfügbaren Termin, der für dich passt.",
  },
  {
    num: "3",
    icon: PlayCircle,
    title: "Webinar anschauen",
    text: "Lehn dich zurück und erfahre Schritt für Schritt, wie der Einstieg in die Fahrzeugüberführung funktioniert.",
  },
];

export const FAQS = [
  {
    q: "Ist das Webinar wirklich kostenlos?",
    a: "Ja. Die Teilnahme am Webinar ist kostenlos.",
  },
  {
    q: "Brauche ich Erfahrung in der Fahrzeugüberführung?",
    a: "Nein. Das Webinar richtet sich ausdrücklich auch an Einsteiger.",
  },
  {
    q: "Muss ich bereits ein Gewerbe haben?",
    a: "Nein, um dir das Webinar anzusehen, musst du noch nicht alle Voraussetzungen erfüllt haben. Im Webinar erfährst du, welche Schritte für eine tatsächliche Tätigkeit relevant sein können.",
  },
  {
    q: "Wie lange dauert das Webinar?",
    a: "Plane ungefähr 60 Minuten ein.",
  },
  {
    q: "Kann jeder mit Fahrzeugüberführungen Geld verdienen?",
    a: "Ob und in welchem Umfang Fahrzeugüberführung für jemanden geeignet und wirtschaftlich sinnvoll ist, hängt von verschiedenen Faktoren ab. Im Webinar lernst du deshalb auch, wie du Aufträge realistisch beurteilst.",
  },
];

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1503376780353-7e6692767b70?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000",
  handover: "https://images.unsplash.com/photo-1652509573480-a190f1c61f6d?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  driving: "https://images.unsplash.com/photo-1577977799980-cd7053d89661?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  sedan: "https://images.unsplash.com/photo-1750380328422-fbe02f196300?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  phone: "https://images.unsplash.com/photo-1548345680-f5475ea5df84?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
  money: "https://images.unsplash.com/photo-1579846703786-afbf4b377f7e?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
  webinar: "https://images.unsplash.com/photo-1625297673326-14790108da55?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
  hamburg: "https://images.unsplash.com/photo-1589797268350-44b2cbae816e?crop=entropy&cs=srgb&fm=jpg&q=85&w=1100",
};

export const HERO_VIDEO_SRC = "/media/founder.mp4";

// Beispiel-Aufträge zur Veranschaulichung (keine Einkommensgarantie).
export const EARNINGS_EXAMPLES = [
  { date: "12.08.2026", client: "Autohaus Nordstern", from: "Hamburg", to: "Pinneberg", km: 30, pay: 50 },
  { date: "14.08.2026", client: "Sixt Autovermietung", from: "Bremen", to: "Hamburg", km: 100, pay: 100 },
  { date: "16.08.2026", client: "ALD Automotive (Leasing)", from: "Berlin", to: "Hannover", km: 300, pay: 180 },
  { date: "19.08.2026", client: "Fleet Logistics GmbH", from: "Hamburg", to: "Stuttgart", km: 600, pay: 290 },
];

// Weitere Community-Stimmen (scharf gerendert statt Screenshot).
export const COMMUNITY_REVIEWS = [
  { handle: "@BlackerRalph", when: "vor 3 Monaten", text: "Ich war letztes Jahr im Multifahrer-Programm. Hat sich auf jeden Fall sehr gelohnt.", likes: 3 },
  { handle: "@MaxR0st1", when: "vor 3 Monaten", text: "Super erklärt, danke!", likes: 1 },
  { handle: "@tomatensugras685", when: "vor 1 Monat", text: "Bin super zufrieden bei Kurier Connect.", likes: 2 },
  { handle: "@Jonas_H", when: "vor 3 Monaten", text: "Habe das Gefühl, dass hier endlich mal jemand ehrlich über die Branche redet und nicht alles nur positiv darstellt.", likes: 5 },
  { handle: "@DidiLando", when: "vor 3 Monaten", text: "Cooles Konzept, feier ich. Man merkt, der Kolja weiß, wovon er spricht.", likes: 4 },
  { handle: "@KevinP1dow", when: "vor 3 Monaten", text: "Der Support ist echt klasse – man kann selbst um 22 Uhr noch anrufen. Gibt es sowas heute noch?", likes: 6 },
  { handle: "@halisg0nic588", when: "vor 1 Monat", text: "Kolja macht echt einen super Job, das muss man mal sagen.", likes: 2 },
  { handle: "@beranenba555", when: "vor 3 Monaten", text: "Endlich mal jemand, der wirklich hält, was er verspricht und nicht nur redet.", likes: 3 },
];

// Beweis-Galerie: echte WhatsApp-Nachrichten von Teilnehmern.
export const PROOF_SHOTS = [
  { src: "/media/reviews/r4.webp", name: "Sabrina" },
  { src: "/media/reviews/r3.png", name: "Andras" },
  { src: "/media/reviews/r2.webp", name: "Heiko" },
  { src: "/media/reviews/r5.webp", name: "Mohammed" },
];

// Echte Teilnehmerstimmen (aus WhatsApp-Nachrichten & Community-Feedback).
export const TESTIMONIALS = [
  {
    name: "Sabrina",
    initials: "SA",
    rating: 5,
    text: "Ich wollte dir sagen, dass ich gerade meine erste Überführung gemacht habe – hat wirklich super geklappt! Danke für die ganzen Infos und Tipps zur Umsetzung. Echt coole Videos und guter Support. 👍",
  },
  {
    name: "Andras",
    initials: "AN",
    rating: 5,
    text: "Hey Kolja, grad mein erstes Auto überführt. Danke dir nochmal für deine Hilfe und deinen Support! ❤️",
  },
  {
    name: "Heiko",
    initials: "HE",
    rating: 5,
    text: "Moin Kolja, ich wollte mich einfach mal bedanken. Dein Support ist wirklich klasse und deine Inhalte sind sehr hilfreich. Danke dir vielmals!",
  },
  {
    name: "Mohammed",
    initials: "MO",
    rating: 5,
    text: "Danke nochmal für alles – bester Job, den ich je hatte. Jetzt möchte ich sogar ein eigenes Team aufbauen! ❤️",
  },
  {
    name: "Kevin",
    initials: "KE",
    rating: 5,
    text: "Der Support ist echt klasse – man kann selbst um 22 Uhr noch anrufen. Gibt es sowas heute überhaupt noch?",
  },
  {
    name: "Max",
    initials: "MX",
    rating: 5,
    text: "Habe das Gefühl, dass hier endlich mal jemand ehrlich über die Branche redet und nicht die ganze Zeit alles nur positiv darstellt.",
  },
];
